module.exports = __webpack_public_path__ + "img/album08_11.b08cd78b.jpg";